import { gsap } from "gsap";
import * as focusTrap from 'focus-trap';

export default {

  setup() {

    console.log('Navigation is set up');
    const responsiveNav = document.querySelector('nav.responsive');

    if(responsiveNav) {
      const menuBtn = responsiveNav.querySelector("#menu-button");
      const menuWrap = responsiveNav.querySelector('.menu-wrap');
      const closeIcon = responsiveNav.querySelector('.close-icon');
      const menuIcon = responsiveNav.querySelector('.menu-icon');
      const navItems = gsap.utils.toArray(".nav-item");
      const topBar = responsiveNav.querySelector('.top-bar');
      const body = document.body;

      var trap = focusTrap.createFocusTrap(responsiveNav, {
        initialFocus: false
      });

      // Accordion

      let groups = gsap.utils.toArray(".menu-group");
      let menus = gsap.utils.toArray(".menu-trigger");
      let menuToggles = groups.map(createAnimation);

      menus.forEach(menu => {
        menu.addEventListener("click", () => toggleMenu(menu));
      });

      function toggleMenu(clickedMenu) {    
        menuToggles.forEach(toggleFn => toggleFn(clickedMenu))
      }

      function createAnimation(element) {
          
        let menu = element.querySelector(".menu-trigger");
        let box  = element.querySelector(".menu-content");
        let arrow = element.querySelector(".arrow");

        const dropdowntl = gsap.timeline().reverse();
        
        dropdowntl
        .to(box, {
          autoAlpha: 1,
          duration: 0,
        })
        .from(box, { 
          height: 0,
          duration: 0.5, 
          ease: "power1.inOut" 
        })
        .to(arrow, {
          rotate: -90,
          duration: 0.5,
          ease: "power1.inOut"
        }, "<")
        .reverse();
        
        return function(clickedMenu) {
          
          if (clickedMenu === menu) {
            dropdowntl.reversed(!dropdowntl.reversed());
          } else {
            dropdowntl.reverse();
          }
        }
      }


      // Main dropdown

      let menuOpen = false;

      const mm = gsap.matchMedia();

      mm.add("(max-width: 1023px)", () => {
        const tl = gsap.timeline().reverse();
        tl
        .to(menuIcon, {
          autoAlpha: 0,
          duration: 0.2
        })
        .to(closeIcon, {
          autoAlpha: 1,
          duration: 0.2
        }, "<")
        .to(menuWrap, {
          autoAlpha: 1,
          duration: 0
        })
        .from(menuWrap, {
          yPercent: -100,
          ease: "power1.out",
          duration: 0.8
        })
        .from(navItems, {
          y: -10,
          autoAlpha: 0,
          duration: 0.2,
          stagger: 0.1,
          ease: "power2.out"
        })
        ;
        const toggleMenu = () => {
          if (menuOpen) {

            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
            document.body.style.position = '';
            responsiveNav.style.position = 'sticky';

            tl.reversed(menuOpen).progress(0);
            menuOpen = false;
            menuBtn.setAttribute("aria-expanded", menuOpen);
            trap.deactivate();

            document.documentElement.style.scrollBehavior = ''

          } else {

            document.body.style.top = '-' + window.scrollY + 'px';
            document.body.style.position = 'fixed';
            responsiveNav.style.position = 'fixed';
            document.documentElement.style.scrollBehavior = 'auto'

            tl.reversed(menuOpen);
            menuOpen = true;
            menuBtn.setAttribute("aria-expanded", menuOpen);
            trap.activate();
          }
        };

        menuBtn.addEventListener("click", toggleMenu);

        return () => {
          menuBtn.removeEventListener("click", toggleMenu);
          menuOpen = false;
          menuBtn.setAttribute("aria-expanded", menuOpen);
          trap.deactivate();
          document.body.style.position = '';
          document.body.style.top = '';
        };
      });

    }

  },
  destroy() {

  },
}